import { render, staticRenderFns } from "./DevelopmentPage.vue?vue&type=template&id=e97e34ea&scoped=true&"
import script from "./DevelopmentPage.vue?vue&type=script&lang=js&"
export * from "./DevelopmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97e34ea",
  null
  
)

export default component.exports